	Object.defineProperty(exports, "__esModule", {
	    value: true
	});exports.default=window.GrimoireJS.Base.Namespace;


//////////////////
// WEBPACK FOOTER
// ./node_modules/grimoirejs/ref/Base/Namespace.js
// module id = 35
// module chunks = 0